export const HOSTNAME = 'http://chiwi-dev.com/loan-collector';

export const environment = {
  production: false
};
